<template>
  <div class="p20 bg-white main">
    <div class="mt20 mb20">
      <span class="title1">上传快递单</span>
    </div>
    <div v-if="!show_success" class="mt50">
      <Form :model="formItem" :label-width="130">
        <FormItem label="出库单号">
          <span class="ml10">{{out_bill_no}}</span>
          <!-- <input class="w300 ivu-input ivu-input-default" v-model="formItem.client_code" /> -->
        </FormItem>
        <FormItem label="选择文件" style="margin-bottom: 5px;">
          <input class="w300 ivu-input ivu-input-default" v-model="selectTxt" />
          <button class="ivu-btn ivu-btn-primary" @click="triggerFile">浏览文件</button>
        </FormItem>
        <!-- <FormItem label="">
          <a @click="download" class="blue">下载Excel模板文件</a>
        </FormItem> -->
        <FormItem label="">
          <button class="ivu-btn ivu-btn-primary" @click="upData">上传文件</button>
        </FormItem>
      </Form>
    </div>



    <form id="uploadForm" style="display: none;">
      <input type="file" id="file" @change="uploadFile">
    </form>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        import_id: '',
        out_bill_no:'',//出库单号
        client_name_code: '',
        client_code: '',
        list: [],
        columns: [{
          title: 'SKU',
          key: 'sku',
          width: 150,
        }, {
          title: '新SKU',
          key: 'new_sku',
          width: 150,
        }, {
          title: '数量',
          key: 'product_count',
          width: 150,
        }, {
          title: '导入结果',
          width: 800,
          render: (h, params) => {
            return h('span', {
              style: {
                cursor: "pointer",
                color: params.row.success ? "green" : 'red'
              },
            }, params.row.success?'成功':params.row.message)
          }
        }],
        formItem: {},
        fileData: '',
        selectTxt: '',
        show_success: false,
        had_error: false, //是否有错误
      }
    },
    methods: {
      triggerFile() {
        $('#file').trigger('click')
      },
      download() {
        this.$axios.get("/WarehouseOut/bill/import/excel/template").then(res => {
          if (res.success && res.data) {
            let a = document.createElement('a'); //创建一个<a></a>标签
            a.href = res.data; //赋值url
            a.download = res.data; //文件名称
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click(); //点击下载
            a.remove(); //删除标签
            this.$Message.info('下载成功');
          }
        })
      },
      uploadFile(event) { //上传文件
        let _file = event.target.files[0];
        this.fileData = _file;
        this.selectTxt = _file.name;
      },
      upData() { //确定上传
        if (!this.selectTxt) {
          this.$Message.error('请上传文件');
          return
        }
        let formData = new FormData();
        formData.append('file', this.fileData);
        this.$axios.post('/WarehouseOut/bill/import/amazon_pdf?out_bill_no=' +this.out_bill_no, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then((data) => {
          if (data.success) {
            this.$Message.success("上传成功");
            this.fileData = "";
            this.selectTxt = "";
            this.$router.push({
              path:'/tuihuozhijian/out'
            })
          } else {
            this.$Message.error(data.msg);
          }
        })
      },
      confirmUp() {
        this.$axios.post('/WarehouseOut/bill/import/confirm?out_bill_no=' + this.out_bill_no).then((data) => {
          if (data.success) {
            this.$router.push({
              path:'/tuihuozhijian/out'
            })
            this.$Message.success('上传成功');
          }
        })
      },
      reupload(){
        window.location.reload()
      }
    },
    created() {
      this.client_name_code = localStorage.getItem('client_name_code') || ''
      this.client_code = localStorage.getItem('client_code') || ''
      if(this.$route.query.out_bill_no){
        this.out_bill_no = this.$route.query.out_bill_no
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/tuihuozhijian/out/upload.express.vue